import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _omit from "lodash/omit";
import _reduce from "lodash/reduce";
import _get from "lodash/get";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createAction } from 'redux-act';
import moment from 'moment';
import { mapKeysDeep } from '@nerdwallet/utilities';
import NwApiSDK from '@nerdwallet/nw-api-sdk';
import { TransactionCategoriesV2, NWFinancialAccountTypes } from "../constants/yodlee";
import { FINANCIAL_PORTAL_PRIMARY_SOURCES, DATE_FORMAT } from "../constants";
import { isIncomeCategory } from "../utils/yodlee";
import { createAsyncAction } from "./utils";
import { FINANCIAL_TRANSACTIONS_AVERAGE_SPENDING_BY_DAY_OF_THE_MONTH, FINANCIAL_TRANSACTIONS_PROJECTION_FOR_MONTH, FINANCIAL_TRANSACTIONS_SPENDING_AND_EARNING_FOR_MONTH_RANGE, FINANCIAL_TRANSACTIONS_SPENDING_BY_DATE_FOR_MONTH, FINANCIAL_TRANSACTIONS_SPENDING_BY_MONTH, FINANCIAL_TRANSACTIONS_TOP_CATEGORIES_SPENDING, FINANCIAL_TRANSACTIONS_TOP_MERCHANT_SPENDING } from "../lib/queries/financial-data-insights";
import { CREATE_FINANCIAL_TRANSACTION, DELETE_FINANCIAL_PORTAL, DELETE_FINANCIAL_TRANSACTION, GET_FINANCIAL_ACCOUNTS_BY_PORTAL, GET_TRANSACTIONS_FOR_USER_QUERY, GET_TRANSACTION_FOR_USER_BY_ID_QUERY, REFRESH_FINANCIAL_PORTAL_MUTATION, UPDATE_FINANCIAL_ACCOUNT_VISIBILITY, UPDATE_FINANCIAL_MERCHANT_TRANSACTION_CATEGORY, UPDATE_FINANCIAL_TRANSACTION, UPDATE_FINANCIAL_TRANSACTION_VISIBILITY } from "../lib/queries/financial-data";
import { GET_MONEY_TRANSFER_ACCOUNT_ELIGIBILITY } from "../lib/queries/money-management";
import { convertFinancialAccountToYodleeAccount, convertFinancialAccountVisibilityToYodleeAccountVisibility, convertFinancialDataTransactionToYodleeTransaction, convertFinancialDataTransactionsToYodleeTransactions, convertPortalToProviderAccount, convertYodleeMerchantCategoryParamsToFinancialDataParams, convertYodleeRefreshParamsToFinancialPortalParams, convertYodleeTransactionParamsToFinancialDataParams } from "../utils/fdp-to-yodlee-transforms";
import { fetchFinancialData, transformFinancialDataProfileToLegacyDataShape } from "../utils/financial-data";

var convertDaySpendingListToDateSpendingMap = function convertDaySpendingListToDateSpendingMap() {
  var daySpendingList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var monthDateMoment = arguments.length > 1 ? arguments[1] : undefined;
  return daySpendingList.reduce(function (acc, _ref) {
    var dayOfTheMonth = _ref.dayOfTheMonth,
        amount = _ref.amount;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, moment(monthDateMoment).set('date', dayOfTheMonth).format(DATE_FORMAT.STANDARD), amount));
  }, {});
};
/**
 * Makes a request to search Identity for a provider using the given query. Used internally by
 * js-auth-tools.
 * */


export var searchProviders = createAsyncAction('searchProviders', function (_ref2) {
  var query = _ref2.query,
      serverRequest = _ref2.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.searchProviders({
        query: query,
        serverRequest: serverRequest
      });
    },
    meta: {
      query: query
    }
  };
});
/**
 * Makes a request to get provider details by providerId to Identity.
 * */

export var getProviderDetails = createAsyncAction('getProviderDetails', function (_ref3) {
  var providerId = _ref3.providerId,
      serverRequest = _ref3.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.getProviderDetails({
        providerId: providerId,
        serverRequest: serverRequest
      });
    },
    meta: {
      providerId: providerId
    }
  };
});
/**
 * Makes a request to login to a provider account given a providerId and the fields necessary to
 * authenticate the user.
 * */

export var loginToProvider = createAsyncAction('loginToProvider', function (_ref4) {
  var providerId = _ref4.providerId,
      addIAV = _ref4.addIAV,
      fields = _ref4.fields,
      serverRequest = _ref4.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.loginToProvider({
        providerId: providerId,
        addIAV: addIAV,
        fields: fields,
        serverRequest: serverRequest
      });
    },
    meta: {
      // this field will have the Yodlee provider id for Yodlee on identity, and marketplace institution id for Yodlee on FDP
      providerId: providerId
    }
  };
});
/**
 * Makes a request attempting IAV verification for a given provider account
 * */

export var attemptProviderIAV = createAsyncAction('attemptProviderIAV', function (_ref5) {
  var providerAccountStateId = _ref5.providerAccountStateId,
      serverRequest = _ref5.serverRequest;
  return {
    makeRequest: function () {
      var _makeRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(state, _ref6) {
        var apolloClient, IdentitySDK, providerAccount;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apolloClient = _ref6.apolloClient, IdentitySDK = _ref6.IdentitySDK;
                providerAccount = _get(state, 'identity.profiles.yodlee_profile.provider_accounts', []).find(function (_providerAccount) {
                  return _get(_providerAccount, 'provider_account_state.id') === providerAccountStateId;
                });

                if (!(_get(providerAccount, 'provider_account_state.primary_source') !== FINANCIAL_PORTAL_PRIMARY_SOURCES.PLAID)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", IdentitySDK.Yodlee.attemptProviderIAV({
                  providerAccountStateId: providerAccountStateId,
                  serverRequest: serverRequest
                }));

              case 4:
                _context.next = 6;
                return apolloClient.query({
                  query: GET_MONEY_TRANSFER_ACCOUNT_ELIGIBILITY,
                  variables: {
                    financialPortalId: providerAccountStateId
                  },
                  fetchPolicy: 'network-only'
                });

              case 6:
                return _context.abrupt("return", _objectSpread(_objectSpread({}, _get(providerAccount, 'provider_account_state')), {}, {
                  state: 'LOGIN_IN_PROGRESS',
                  previous_state: 'ACTIVE'
                }));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function makeRequest(_x, _x2) {
        return _makeRequest.apply(this, arguments);
      }

      return makeRequest;
    }()
  };
});
/**
 * Makes a request attempting MFA for a given provider account using the fields necessary to
 * authenticate the user.
 * */

export var attemptProviderMFA = createAsyncAction('attemptProviderMFA', function (_ref7) {
  var providerAccountId = _ref7.providerAccountId,
      addIAV = _ref7.addIAV,
      fields = _ref7.fields,
      serverRequest = _ref7.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.attemptProviderMFA({
        providerAccountId: providerAccountId,
        addIAV: addIAV,
        fields: fields,
        serverRequest: serverRequest
      });
    },
    meta: {
      providerAccountId: providerAccountId
    }
  };
});
export var getProviderAccountStatus = createAsyncAction('getProviderAccountStatus', function (_ref8) {
  var providerAccountId = _ref8.providerAccountId,
      serverRequest = _ref8.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.getProviderAccountStatus({
        providerAccountId: providerAccountId,
        serverRequest: serverRequest
      });
    },
    meta: {
      providerAccountId: providerAccountId
    }
  };
});
export var getFinancialAccounts = createAsyncAction('getFinancialAccounts', function (_ref9) {
  var accountId = _ref9.accountId,
      serverRequest = _ref9.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.getFinancialAccounts({
        accountId: accountId,
        serverRequest: serverRequest
      });
    },
    meta: {
      accountId: accountId
    }
  };
});
export var setSelfReportedData = createAsyncAction('setSelfReportedData', function (_ref10) {
  var accountId = _ref10.accountId,
      extraData = _ref10.extraData,
      serverRequest = _ref10.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.setSelfReportedData({
        accountId: accountId,
        extraData: extraData,
        serverRequest: serverRequest
      });
    },
    meta: {
      accountId: accountId
    }
  };
});
export var getInvestmentHoldings = createAsyncAction('getInvestmentHoldings', function (_ref11) {
  var accountId = _ref11.accountId,
      serverRequest = _ref11.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.getInvestmentHoldings({
        accountId: accountId,
        serverRequest: serverRequest
      });
    },
    meta: {
      accountId: accountId
    }
  };
});
/**
 * Creates a new transaction
 * @param {Object} transaction
 * @param {string} transaction.accountId  The ID of the account to associate the transaction with
 * @param {number} transaction.amount  The amount of the transaction to be created
 * @param {string} transaction.category  The category of the transaction to be created
 * @param {Date}   transaction.date  The date of the transaction to be created
 * @param {string} transaction.description  The description of the transaction to be created
 * @param {string} transaction.merchantName The merchant of the transaction to be created
 * @param {string} transaction.type  The type of the transaction to be created
 * */

export var createTransaction = createAsyncAction('Create transaction', function (_ref12) {
  var accountId = _ref12.accountId,
      amount = _ref12.amount,
      category = _ref12.category,
      date = _ref12.date,
      description = _ref12.description,
      merchantName = _ref12.merchantName,
      type = _ref12.type;
  return {
    makeRequest: function () {
      var _makeRequest2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_state, _ref13) {
        var _financialData$data;

        var apolloClient, amountInCents, dateString, financialData, financialTransaction;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                apolloClient = _ref13.apolloClient;
                // round to prevent floating point errors as backend expects strictly integers
                amountInCents = Math.round(amount * 100);
                dateString = moment.utc(date).toISOString();
                _context2.next = 5;
                return apolloClient.mutate({
                  mutation: CREATE_FINANCIAL_TRANSACTION,
                  variables: {
                    accountId: accountId,
                    amount: amountInCents,
                    category: category,
                    date: dateString,
                    description: description,
                    merchantName: merchantName,
                    type: type
                  }
                });

              case 5:
                financialData = _context2.sent;
                financialTransaction = financialData === null || financialData === void 0 ? void 0 : (_financialData$data = financialData.data) === null || _financialData$data === void 0 ? void 0 : _financialData$data.createFinancialTransaction;
                return _context2.abrupt("return", convertFinancialDataTransactionToYodleeTransaction(financialTransaction));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function makeRequest(_x3, _x4) {
        return _makeRequest2.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      amount: amount,
      category: category,
      date: date,
      description: description,
      merchantName: merchantName,
      type: type
    }
  };
});
/**
 * Edits various fields of a transaction given by transactionId
 *
 * @param {Object} transaction
 * @param {number} transaction.amount  The new amount of the transaction
 * @param {string} transaction.category  The new category to recategorize the transaction to
 * @param {Date} transaction.date  The new date of the transaction
 * @param {string} transaction.merchantName The new merchant of the transaction
 * @param {string} transaction.type  The new type of the transaction
 * @param {string} transaction.previousAmount  The previous amount of the transaction
 * @param {string} transaction.previousCategory The previous category that the transaction was in
 * @param {Date} transaction.previousDate  The previous date that the transaction was in
 * @param {string} transaction.previousMerchantName The previous merchant of the transaction
 * @param {string} transaction.previousType  The previous type of the transaction to be created
 * @param {string} transaction.transactionId  The transaction ID of the transaction to recategorize
 * */

export var editTransaction = createAsyncAction('Edit transaction', function (_ref14) {
  var amount = _ref14.amount,
      category = _ref14.category,
      date = _ref14.date,
      merchantName = _ref14.merchantName,
      type = _ref14.type,
      previousAmount = _ref14.previousAmount,
      previousCategory = _ref14.previousCategory,
      previousDate = _ref14.previousDate,
      previousMerchantName = _ref14.previousMerchantName,
      previousType = _ref14.previousType,
      transactionId = _ref14.transactionId;
  return {
    makeRequest: function () {
      var _makeRequest3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_state, _ref15) {
        var _financialData$data2;

        var apolloClient, amountInCents, dateString, financialData, financialTransaction;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                apolloClient = _ref15.apolloClient;
                // round to prevent floating point errors as backend expects strictly integers
                amountInCents = Math.round(amount * 100);
                dateString = moment.utc(date).toISOString();
                _context3.next = 5;
                return apolloClient.mutate({
                  mutation: UPDATE_FINANCIAL_TRANSACTION,
                  variables: {
                    amount: amountInCents,
                    category: category,
                    date: dateString,
                    merchantName: merchantName,
                    type: type,
                    transactionId: transactionId
                  }
                });

              case 5:
                financialData = _context3.sent;
                financialTransaction = financialData === null || financialData === void 0 ? void 0 : (_financialData$data2 = financialData.data) === null || _financialData$data2 === void 0 ? void 0 : _financialData$data2.updateFinancialTransaction;
                return _context3.abrupt("return", convertFinancialDataTransactionToYodleeTransaction(financialTransaction));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function makeRequest(_x5, _x6) {
        return _makeRequest3.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      amount: amount,
      category: category,
      date: date,
      merchantName: merchantName,
      type: type,
      previousAmount: previousAmount,
      previousCategory: previousCategory,
      previousDate: previousDate,
      previousMerchantName: previousMerchantName,
      previousType: previousType,
      transactionId: transactionId
    }
  };
});
/**
 * Deletes the transaction given by transactionId
 *
 * @param {Object} transaction
 * @param {string} transaction.transactionId  The ID of the transaction to be deleted
 * */

export var deleteTransaction = createAsyncAction('Delete transaction', function (_ref16) {
  var transactionId = _ref16.transactionId;
  return {
    makeRequest: function () {
      var _makeRequest4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(state, _ref17) {
        var _financialTransaction, _financialData$data3, _financialData$data3$;

        var apolloClient, financialTransactionData, deletedFinancialTransaction, financialData, isSuccess;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                apolloClient = _ref17.apolloClient;
                _context4.next = 3;
                return apolloClient.query({
                  query: GET_TRANSACTION_FOR_USER_BY_ID_QUERY,
                  fetchPolicy: 'cache-first',
                  variables: {
                    transactionId: transactionId
                  }
                });

              case 3:
                financialTransactionData = _context4.sent;
                deletedFinancialTransaction = financialTransactionData === null || financialTransactionData === void 0 ? void 0 : (_financialTransaction = financialTransactionData.data) === null || _financialTransaction === void 0 ? void 0 : _financialTransaction.financialTransactionById; // attempt to delete the transaction

                _context4.next = 7;
                return apolloClient.mutate({
                  mutation: DELETE_FINANCIAL_TRANSACTION,
                  variables: {
                    transactionId: transactionId
                  }
                });

              case 7:
                financialData = _context4.sent;
                isSuccess = financialData === null || financialData === void 0 ? void 0 : (_financialData$data3 = financialData.data) === null || _financialData$data3 === void 0 ? void 0 : (_financialData$data3$ = _financialData$data3.deleteFinancialTransaction) === null || _financialData$data3$ === void 0 ? void 0 : _financialData$data3$.success;

                if (!isSuccess) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return", convertFinancialDataTransactionToYodleeTransaction(deletedFinancialTransaction));

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function makeRequest(_x7, _x8) {
        return _makeRequest4.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      transactionId: transactionId
    }
  };
});
/**
 * Creates a category rule for all transactions with the specified merchant
 *
 * @param transactionId {String} The transaction ID of the transaction to recategorize
 * @param previousCategory {String} The previous category that the transaction was in
 * @param category {String} The new category to recategorize the transaction to
 * @param date {String} The date of the transactions. Useful for recalculating rollups under the
 * hood.
 * */

export var createMerchantCategoryRule = createAsyncAction('createMerchantCategoryRule', function (_ref18) {
  var transactionId = _ref18.transactionId,
      canonicalMerchantName = _ref18.canonicalMerchantName,
      category = _ref18.category,
      previousCategory = _ref18.previousCategory;
  return {
    makeRequest: function () {
      var _makeRequest5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_state, _ref19) {
        var apolloClient, financialData;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                apolloClient = _ref19.apolloClient;
                _context5.next = 3;
                return apolloClient.mutate({
                  mutation: UPDATE_FINANCIAL_MERCHANT_TRANSACTION_CATEGORY,
                  variables: convertYodleeMerchantCategoryParamsToFinancialDataParams({
                    canonicalMerchantName: canonicalMerchantName,
                    category: category,
                    previousCategory: previousCategory,
                    transactionId: transactionId
                  })
                });

              case 3:
                financialData = _context5.sent;
                return _context5.abrupt("return", _get(financialData, 'data.updateFinancialMerchantCategory'));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function makeRequest(_x9, _x10) {
        return _makeRequest5.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      transactionId: transactionId,
      category: category,
      previousCategory: previousCategory,
      canonicalMerchantName: canonicalMerchantName
    }
  };
});
/**
 * Recategorizes a merchant and updates the view. This can potentially trigger loading of transactions
 * if the user is currently viewing the category that they're recategorizing this merchant into.
 *
 * @param merchantName {String} The merchant name to recategorize
 * @param category {String} The category to recategorize the merchant in to
 * */

export var recategorizeMerchant = createAsyncAction('recategorizeMerchant', function (_ref20) {
  var serverRequest = _ref20.serverRequest,
      canonicalMerchantName = _ref20.canonicalMerchantName,
      category = _ref20.category;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.createMerchantCategoryRule({
        serverRequest: serverRequest,
        canonicalMerchantName: canonicalMerchantName,
        category: category
      });
    },
    meta: {
      canonicalMerchantName: canonicalMerchantName,
      category: category
    }
  };
});
/**
 * Helper method to update the visibility of a transaction; used by both the show and hide actions.
 *
 * @param {Object} apolloClient - instance of apolloClient
 * @param {boolean} isHidden - whether we want to show or hide the transaction
 * @param {string} transactionId - the id of the transaction to show or hide
 */

var updateTransactionVisibility = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref21) {
    var _financialData$data4;

    var apolloClient, isHidden, transactionId, financialData, financialTransaction;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            apolloClient = _ref21.apolloClient, isHidden = _ref21.isHidden, transactionId = _ref21.transactionId;
            _context6.next = 3;
            return apolloClient.mutate({
              mutation: UPDATE_FINANCIAL_TRANSACTION_VISIBILITY,
              variables: {
                transactionId: transactionId,
                isHidden: isHidden
              },
              optimisticResponse: {
                __typename: 'Mutation',
                updateFinancialTransactionVisibility: {
                  __typename: 'FinancialTransaction',
                  id: transactionId,
                  isHidden: isHidden
                }
              }
            });

          case 3:
            financialData = _context6.sent;
            financialTransaction = financialData === null || financialData === void 0 ? void 0 : (_financialData$data4 = financialData.data) === null || _financialData$data4 === void 0 ? void 0 : _financialData$data4.updateFinancialTransactionVisibility;
            return _context6.abrupt("return", convertFinancialDataTransactionToYodleeTransaction(financialTransaction));

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function updateTransactionVisibility(_x11) {
    return _ref22.apply(this, arguments);
  };
}();
/**
 * Create a tag rule for a transaction.
 * NOTE: this is now synonymous with hiding a transaction, as no other "tags" are used or supported.
 *
 * @param {string} transactionId
 * @param {string} tag
 * */


export var createTransactionTag = createAsyncAction('createTransactionTag', function (_ref23) {
  var transactionId = _ref23.transactionId,
      tag = _ref23.tag;
  return {
    makeRequest: function () {
      var _makeRequest6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_state, _ref24) {
        var apolloClient;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                apolloClient = _ref24.apolloClient;
                return _context7.abrupt("return", updateTransactionVisibility({
                  apolloClient: apolloClient,
                  transactionId: transactionId,
                  isHidden: true
                }));

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function makeRequest(_x12, _x13) {
        return _makeRequest6.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      transactionId: transactionId,
      tag: tag
    }
  };
});
/**
 * Removes a tag from a transaction.
 * NOTE: this is now synonymous with un-hiding a transaction, as no other "tags" are used or supported.
 *
 * @param {string} transactionId
 * @param {string} tag
 * */

export var deleteTransactionTag = createAsyncAction('deleteTransactionTag', function (_ref25) {
  var transactionId = _ref25.transactionId,
      tag = _ref25.tag;
  return {
    makeRequest: function makeRequest(_state, _ref26) {
      var apolloClient = _ref26.apolloClient;
      return updateTransactionVisibility({
        apolloClient: apolloClient,
        transactionId: transactionId,
        isHidden: false
      });
    },
    meta: {
      transactionId: transactionId,
      tag: tag
    }
  };
});
/**
 * Add a tag rule for a merchant.
 *
 * This can potentially trigger loading of transactions if the user is somehow
 * currently viewing the tag that they're adding the merchant to.
 *
 * @param {string} merchantName
 * @param {string} tag
 * */

export var createMerchantTag = createAsyncAction('createMerchantTag', function (_ref27) {
  var serverRequest = _ref27.serverRequest,
      merchantId = _ref27.merchantId,
      tag = _ref27.tag;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.createMerchantTagRule({
        serverRequest: serverRequest,
        merchantId: merchantId,
        tag: tag
      });
    },
    meta: {
      merchantId: merchantId,
      tag: tag
    }
  };
});
/**
 * Delete a merchant tag.
 *
 * @param {string} merchantName The merchant name to add a tag to
 * @param {string} tag          The tag to add to all transactions of the merchant
 * */

export var deleteMerchantTag = createAsyncAction('deleteMerchantTag', function (_ref28) {
  var serverRequest = _ref28.serverRequest,
      merchantId = _ref28.merchantId,
      tag = _ref28.tag;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.deleteMerchantTagRule({
        serverRequest: serverRequest,
        merchantId: merchantId,
        tag: tag
      });
    },
    meta: {
      merchantId: merchantId,
      tag: tag
    }
  };
});
/**
 * Sets the transactions filter in the redux store. Used in the getTransactionsView selector, as
 * well as optimizations for categorization and tags.
 *
 * @param filter {Object} An object that represents a particular view. A filter object can contain
 * 0 or 1 keys which represent the current view filter. The current supported filters are
 *   - category (e.g. { category: 'income' })
 *   - merchantName (e.g. { merchantName: 'Uber' })
 *   - accountId (e.g. { accountId: 12345 })
 *   - tag (e.g. { tag: 'keep_an_eye' })
 *   - all (e.g. {})
 * */

export var setTransactionsFilter = createAction('Set transactions filter', function (filter) {
  var transactionCategoryVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return {
    filter: filter,
    transactionCategoryVersion: transactionCategoryVersion
  };
});
/**
 * Resets all transaction data. This action is called in certain cases where we are unable to
 * consolidate the cached transactions with transactions in Identity. Currently this happens when
 * a new account is linked, but could also happen in the future where user-initiated refreshes
 * could trigger Identity to sync transactions with Yodlee.
 * */

export var resetTransactions = createAction('Reset transactions');
/**
 * Updates the view list. Called internally by js-auth-tools
 *
 * @param limit {Number} The desired length of the view list
 * */

export var updateTransactionsViewList = createAction('Update transactions view list', function (limit) {
  return {
    limit: limit
  };
});
/**
 * Attempts to append transactions to the viewLIst the transactions reducer. If the next page of
 * transactions is not available then a new transactions request will be initiated. Otherwise,
 * if the transactions are already available and cached by the reducer, the viewList is
 * updated to include those new transactions.
 *
 * @param limit {Number}
 * */

export var getNextTransactionsPage = createAction('Get next transactions page', function (limit) {
  return {
    limit: limit || 50
  };
});
/**
 * Makes a request to get transaction rollups for a given month, and places them in the store.
 * Month should be a valid Date object. Any Date representing a day of a given month will request
 * the entire month. BaseType can be CREDIT or DEBIT.
 *
 * @deprecated Use {@link getTransactionsMonthCashFlow}
 *
 * @param month {Date} A valid date object of the desired month
 * @param filter {Object} A valid filter object
 * @param baseType {String} CREDIT or DEBIT
 * */

export var getTransactionsMonthRollup = createAsyncAction('getTransactionsMonthRollup', function (_ref29) {
  var serverRequest = _ref29.serverRequest,
      month = _ref29.month,
      _ref29$filter = _ref29.filter,
      filter = _ref29$filter === void 0 ? {} : _ref29$filter,
      baseType = _ref29.baseType;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.getTransactionsSummary({
        accountId: filter.accountId,
        baseType: baseType,
        endDate: moment(month).endOf('month').format(DATE_FORMAT.STANDARD),
        excludeAccountTypes: [opts.IdentitySDK.ACCOUNT_TYPES.INVESTMENT],
        excludeCategories: filter.accountId ? undefined : [opts.IdentitySDK.TRANSACTION_CATEGORIES.OMIT],
        excludeTags: [opts.IdentitySDK.TRANSACTION_TAGS.IGNORED],
        includeCategories: filter.category && [filter.category],
        includeTags: filter.tag && [filter.tag],
        merchantName: filter.merchantName,
        serverRequest: serverRequest,
        startDate: moment(month).date(1).format(DATE_FORMAT.STANDARD),
        status: opts.IdentitySDK.TRANSACTION_STATUS.POSTED
      });
    },
    meta: {
      month: moment(month).date(1).format(DATE_FORMAT.STANDARD),
      filter: filter,
      baseType: baseType
    }
  };
});
/**
 * Loads transactions for a particular filter until {count} transactions have been reached, or
 * there are no more transactions to sync.
 *
 * @param count {Number} The desired number of transactions to pull from identity
 * @param filter {Object} The filter to pull the transactions into
 * */

export var getTransactionsBulkStart = createAction('Get Transactions Bulk Start', function (count, filter) {
  return {
    count: count,
    filter: filter
  };
});
/**
 * An action dispatched when bulk loading has completed.
 * */

export var getTransactionsBulkEnd = createAction('Get Transactions Bulk End');
/**
 * Makes a request to identity to fetch additional transactions. Used internally by js-auth-tools.
 * Clients should use getNextTransactionsPage().
 * */

export var getTransactions = createAsyncAction('getTransactions', function (_ref30) {
  var _ref30$bulkOptions = _ref30.bulkOptions,
      bulkOptions = _ref30$bulkOptions === void 0 ? undefined : _ref30$bulkOptions,
      _ref30$filter = _ref30.filter,
      filter = _ref30$filter === void 0 ? {} : _ref30$filter,
      _ref30$includeDisable = _ref30.includeDisabledAccounts,
      includeDisabledAccounts = _ref30$includeDisable === void 0 ? false : _ref30$includeDisable,
      _ref30$limit = _ref30.limit,
      limit = _ref30$limit === void 0 ? 50 : _ref30$limit,
      offset = _ref30.offset,
      resultsSetToken = _ref30.resultsSetToken,
      shouldReset = _ref30.shouldReset;
  return {
    makeRequest: function () {
      var _makeRequest7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(state, _ref31) {
        var apolloClient, _convertYodleeTransac, accountId, category, includeHiddenAccounts, isHidden, merchantName, pagination, financialData, financialTransactionsData, financialTransactions;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                apolloClient = _ref31.apolloClient;
                _convertYodleeTransac = convertYodleeTransactionParamsToFinancialDataParams({
                  bulkOptions: bulkOptions,
                  filter: filter,
                  includeDisabledAccounts: includeDisabledAccounts,
                  limit: limit,
                  offset: offset,
                  resultsSetToken: resultsSetToken,
                  shouldReset: shouldReset
                }, state), accountId = _convertYodleeTransac.accountId, category = _convertYodleeTransac.category, includeHiddenAccounts = _convertYodleeTransac.includeHiddenAccounts, isHidden = _convertYodleeTransac.isHidden, merchantName = _convertYodleeTransac.merchantName, pagination = _convertYodleeTransac.pagination;
                _context8.next = 4;
                return apolloClient.query({
                  query: GET_TRANSACTIONS_FOR_USER_QUERY,
                  fetchPolicy: 'network-only',
                  variables: {
                    filter: {
                      accountId: accountId,
                      category: category,
                      includeHiddenAccounts: includeHiddenAccounts,
                      isHidden: isHidden,
                      merchantName: merchantName
                    },
                    pagination: pagination
                  }
                });

              case 4:
                financialData = _context8.sent;
                financialTransactionsData = _get(financialData, 'data.financialTransactions');
                financialTransactions = _get(financialTransactionsData, 'transactions', []);
                return _context8.abrupt("return", {
                  limit: _get(financialTransactionsData, 'pagination.limit'),
                  offset: _get(financialTransactionsData, 'pagination.offset', 0),
                  results_set_token: _get(financialTransactionsData, 'pagination.resultSetToken'),
                  transactions: convertFinancialDataTransactionsToYodleeTransactions(financialTransactions)
                });

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function makeRequest(_x14, _x15) {
        return _makeRequest7.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      bulkOptions: bulkOptions,
      filter: filter,
      limit: limit,
      offset: offset,
      resultsSetToken: resultsSetToken,
      shouldReset: shouldReset
    }
  };
});
/**
 * Makes a request to identity to fetch a specific transaction by ID
 * @param params
 * @param {string} params.transactionId The transaction ID
 * */

export var getTransactionById = createAsyncAction('getTransactionById', function () {
  var _ref32 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      transactionId = _ref32.transactionId;

  return {
    makeRequest: function () {
      var _makeRequest8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(_state, _ref33) {
        var apolloClient, financialData, financialTransaction;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                apolloClient = _ref33.apolloClient;
                _context9.next = 3;
                return apolloClient.query({
                  query: GET_TRANSACTION_FOR_USER_BY_ID_QUERY,
                  fetchPolicy: 'network-only',
                  variables: {
                    transactionId: transactionId
                  }
                });

              case 3:
                financialData = _context9.sent;
                financialTransaction = _get(financialData, 'data.financialTransactionById');
                return _context9.abrupt("return", {
                  transaction: convertFinancialDataTransactionToYodleeTransaction(financialTransaction)
                });

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function makeRequest(_x16, _x17) {
        return _makeRequest8.apply(this, arguments);
      }

      return makeRequest;
    }()
  };
});
/**
 * Makes a request to Identity to fetch daily rollup amounts for the target and previous month.
 * The resulting values are added to the yodlee transactions store.  The dayInTargetMonth argument
 * can be any day within the target month for the user's local timezone.
 *
 * @deprecated Use {@link getDailyTransactionsCashFlow}
 * */

export var getDailyTransactionsSummary = createAsyncAction('getDailyTransactionsSummary', function () {
  var _ref34 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      serverRequest = _ref34.serverRequest,
      baseType = _ref34.baseType,
      _ref34$dayInTargetMon = _ref34.dayInTargetMonth,
      dayInTargetMonth = _ref34$dayInTargetMon === void 0 ? moment().format(DATE_FORMAT.STANDARD) : _ref34$dayInTargetMon;

  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.getDailyTransactionsSummary({
        baseType: baseType,
        dayInTargetMonth: dayInTargetMonth,
        excludeAccountTypes: [opts.IdentitySDK.ACCOUNT_TYPES.INVESTMENT],
        excludeCategories: [opts.IdentitySDK.TRANSACTION_CATEGORIES.OMIT],
        excludeTags: [opts.IdentitySDK.TRANSACTION_TAGS.IGNORED],
        serverRequest: serverRequest,
        status: opts.IdentitySDK.TRANSACTION_STATUS.POSTED
      });
    },
    meta: {
      baseType: baseType,
      dayInTargetMonth: dayInTargetMonth
    }
  };
});
/**
 * Makes a request to Identity to fetch an ordered list of top merchants based on the slices you
 * provide. If one of the slices is 'window', you MUST include startDate and endDate. The limit
 * param defines at most how many merchants we will get back
 */

export var getTopMerchants = createAsyncAction('getTopMerchants', function (_ref35) {
  var endDate = _ref35.endDate,
      startDate = _ref35.startDate,
      limit = _ref35.limit;
  return {
    makeRequest: function () {
      var _makeRequest9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(_state, _ref36) {
        var apolloClient, response, topMerchants;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                apolloClient = _ref36.apolloClient;
                _context10.next = 3;
                return apolloClient.query({
                  query: FINANCIAL_TRANSACTIONS_TOP_MERCHANT_SPENDING,
                  fetchPolicy: 'network-only',
                  variables: {
                    dateInTargetStartMonth: startDate,
                    dateInTargetEndMonth: endDate,
                    pagination: {
                      limit: limit
                    }
                  }
                });

              case 3:
                response = _context10.sent;
                topMerchants = _get(response, 'data.financialTransactionsTopMerchantsBySpending.topMerchantsBySpending');
                return _context10.abrupt("return", {
                  window: mapKeysDeep(topMerchants, {
                    merchantName: 'canonical_merchant_name',
                    amount: 'sum_amount',
                    __typename: undefined
                  })
                });

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function makeRequest(_x18, _x19) {
        return _makeRequest9.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      startDate: startDate,
      endDate: endDate
    }
  };
});
/**
 * Fetches an ordered list of spending categories for a given startDate and endDate.
 */

export var getCategoryWindowRollups = createAsyncAction('getCategoryWindowRollups', function (_ref37) {
  var endDate = _ref37.endDate,
      startDate = _ref37.startDate,
      today = _ref37.today;
  return {
    makeRequest: function () {
      var _makeRequest10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(_state, _ref38) {
        var apolloClient, response, topCategories;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                apolloClient = _ref38.apolloClient;
                _context11.next = 3;
                return apolloClient.query({
                  query: FINANCIAL_TRANSACTIONS_TOP_CATEGORIES_SPENDING,
                  fetchPolicy: 'network-only',
                  variables: {
                    dateInTargetStartMonth: startDate,
                    dateInTargetEndMonth: endDate
                  }
                });

              case 3:
                response = _context11.sent;
                topCategories = _get(response, 'data.financialTransactionsTopCategoriesBySpending.topCategoriesBySpending');
                return _context11.abrupt("return", {
                  window: mapKeysDeep(topCategories, {
                    category: 'category_v2',
                    amount: 'sum_amount',
                    __typename: undefined
                  })
                });

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function makeRequest(_x20, _x21) {
        return _makeRequest10.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      endDate: endDate,
      startDate: startDate,
      today: today
    }
  };
});
/**
 * This action updates the "categoryWindowRollups" reducer.
 *
 * This needs to run after running other actions that impact category rollups.
 *
 * This action should be dispatched from middleware, and shouldn't be called by the client.
 */

export var updateCategoryWindowRollups = createAction('updateCategoryWindowRollups', function (_ref39) {
  var amount = _ref39.amount,
      category = _ref39.category,
      date = _ref39.date;
  return {
    amount: amount,
    category: category,
    date: date
  };
});
/**
 * This action updates the "topMerchants" reducer.
 *
 * This needs to run after running other actions that impact amounts in "topMerchants".
 *
 * This action should be dispatched from middleware, and shouldn't be called by the client.
 */

export var updateTopMerchants = createAction('updateTopMerchants', function (_ref40) {
  var amount = _ref40.amount,
      canonicalMerchantName = _ref40.canonicalMerchantName,
      date = _ref40.date;
  return {
    canonicalMerchantName: canonicalMerchantName,
    amount: amount,
    date: date
  };
});
/**
 * Makes a request to Identity to fetch estimated income, which is based on either
 * (1) the user's self-reported data, or
 * (2) an average of their past income
 *
 * @deprecated Use {@link getCashFlowProjection}
 */

export var getMonthlyEstimatedIncome = createAsyncAction('getMonthlyEstimatedIncome', function (_ref41) {
  var _ref41$dayInTargetMon = _ref41.dayInTargetMonth,
      dayInTargetMonth = _ref41$dayInTargetMon === void 0 ? moment().format(DATE_FORMAT.STANDARD) : _ref41$dayInTargetMon,
      serverRequest = _ref41.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.getTransactionsInsAndOuts({
        dayInTargetMonth: dayInTargetMonth,
        serverRequest: serverRequest
      });
    },
    meta: {
      dayInTargetMonth: dayInTargetMonth
    }
  };
});
/**
 * Makes a request to Identity to fetch cash flow for the given month.
 */

export var getTransactionsMonthCashFlow = createAsyncAction('getTransactionsMonthCashFlow', function (_ref42) {
  var dayInTargetMonth = _ref42.dayInTargetMonth,
      today = _ref42.today,
      _ref42$filter = _ref42.filter,
      filter = _ref42$filter === void 0 ? {} : _ref42$filter;
  return {
    makeRequest: function () {
      var _makeRequest11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(state, _ref43) {
        var apolloClient, result, _get2, earning, spending;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                apolloClient = _ref43.apolloClient;
                _context12.next = 3;
                return apolloClient.query({
                  query: FINANCIAL_TRANSACTIONS_SPENDING_AND_EARNING_FOR_MONTH_RANGE,
                  fetchPolicy: 'network-only',
                  variables: {
                    dateInStartMonth: moment(dayInTargetMonth).format(DATE_FORMAT.STANDARD),
                    dateInEndMonth: today || moment(dayInTargetMonth).format(DATE_FORMAT.STANDARD),
                    filter: {
                      accountId: filter.accountId,
                      excludeHiddenTransactions: true,
                      includeDisabledAccounts: !!filter.accountId,
                      includeTags: filter.tag && [filter.tag],
                      merchantName: filter.merchantName
                    }
                  }
                });

              case 3:
                result = _context12.sent;
                _get2 = _get(result, 'data.financialTransactionsSpendingAndEarningForMonthRange.spendingAndEarningForMonthRange'), earning = _get2.earning, spending = _get2.spending;
                return _context12.abrupt("return", {
                  earning: earning,
                  spending: spending
                });

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function makeRequest(_x22, _x23) {
        return _makeRequest11.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      dayInTargetMonth: dayInTargetMonth,
      filter: filter
    }
  };
});
/**
 * Makes a request to Identity to fetch cash flow for each month in the given date range.
 */

export var getTransactionsCashFlowMonthly = createAsyncAction('getTransactionsCashFlowMonthly', function (_ref44) {
  var serverRequest = _ref44.serverRequest,
      dayInEndMonth = _ref44.dayInEndMonth,
      dayInStartMonth = _ref44.dayInStartMonth,
      _ref44$filter = _ref44.filter,
      filter = _ref44$filter === void 0 ? {} : _ref44$filter;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.getTransactionsCashFlowMonthly({
        accountId: filter.accountId,
        categoryVersion: opts.transactionCategoryVersion,
        dayInEndMonth: dayInEndMonth,
        dayInStartMonth: dayInStartMonth,
        excludeAccountTypes: [opts.IdentitySDK.ACCOUNT_TYPES.INVESTMENT],
        excludeTags: [opts.IdentitySDK.TRANSACTION_TAGS.IGNORED],
        includeDisabledAccounts: !!filter.accountId,
        includeTags: filter.tag && [filter.tag],
        canonicalMerchantName: filter.merchantName,
        serverRequest: serverRequest,
        status: opts.IdentitySDK.TRANSACTION_STATUS.POSTED
      });
    },
    meta: {
      filter: filter
    }
  };
});
/**
 * Makes a request to query0 to fetch net spending for each month in the given date range.
 *
 * Note: Include at least one of "category" or "exclude_categories" to the endpoint,
 * or else spending logic will be applied across all categories, including weird ones like
 * income/transfers, which is probably not what you want.
 */

export var getTransactionsSpendingMonthly = createAsyncAction('getTransactionsSpendingMonthly', function (_ref45) {
  var dayInStartMonth = _ref45.dayInStartMonth,
      dayInEndMonth = _ref45.dayInEndMonth,
      _ref45$filter = _ref45.filter,
      filter = _ref45$filter === void 0 ? {} : _ref45$filter;
  return {
    makeRequest: function () {
      var _makeRequest12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(_state, opts) {
        var excludeCategories, result, spendingByMonth, response;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                excludeCategories = [TransactionCategoriesV2.TRANSFERS];

                if (!isIncomeCategory(filter.category)) {
                  excludeCategories.push(TransactionCategoriesV2.INCOME);
                }

                _context13.next = 4;
                return opts.apolloClient.query({
                  query: FINANCIAL_TRANSACTIONS_SPENDING_BY_MONTH,
                  fetchPolicy: 'network-only',
                  variables: {
                    dateInTargetStartMonth: dayInStartMonth,
                    dateInTargetEndMonth: dayInEndMonth,
                    filter: {
                      accountId: filter.accountId,
                      excludeAccountTypes: [NWFinancialAccountTypes.INVESTMENT],
                      excludeCategories: excludeCategories,
                      excludeHiddenTransactions: true,
                      categories: filter.category && [filter.category],
                      includeTags: filter.tag && [filter.tag],
                      merchantName: filter.merchantName
                    }
                  }
                });

              case 4:
                result = _context13.sent;
                spendingByMonth = _get(result, 'data.financialTransactionsSpendingByMonth.spendingByMonth', {});
                response = _reduce(spendingByMonth, function (acc, _ref46) {
                  var amount = _ref46.amount,
                      date = _ref46.date;
                  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, date, amount));
                }, {});
                return _context13.abrupt("return", response);

              case 8:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function makeRequest(_x24, _x25) {
        return _makeRequest12.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      filter: filter
    }
  };
});
/**
 * Makes a request to Identity to fetch the net total of transaction amounts for
 * each day in the target month AND previous month.
 * */

export var getDailyTransactionsCashFlow = createAsyncAction('getDailyTransactionsCashFlow', function (_ref47) {
  var dayInTargetMonth = _ref47.dayInTargetMonth;
  return {
    makeRequest: function () {
      var _makeRequest13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(_state, _ref48) {
        var apolloClient, response, data, spendingByDayOfTheMonthForPriorMonth, spendingByDayOfTheMonthForTargetMonth, targetMonthDate;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                apolloClient = _ref48.apolloClient;
                _context14.next = 3;
                return apolloClient.query({
                  fetchPolicy: 'network-only',
                  query: FINANCIAL_TRANSACTIONS_SPENDING_BY_DATE_FOR_MONTH,
                  variables: {
                    dateInTargetMonth: dayInTargetMonth
                  }
                });

              case 3:
                response = _context14.sent;
                data = _get(response, 'data.financialTransactionsSpendingByDateForMonth', {});
                spendingByDayOfTheMonthForPriorMonth = data.spendingByDayOfTheMonthForPriorMonth, spendingByDayOfTheMonthForTargetMonth = data.spendingByDayOfTheMonthForTargetMonth;
                targetMonthDate = moment(dayInTargetMonth);
                return _context14.abrupt("return", {
                  spending_prior_month: convertDaySpendingListToDateSpendingMap(spendingByDayOfTheMonthForPriorMonth, moment(targetMonthDate).subtract(1, 'month')),
                  spending_target_month: convertDaySpendingListToDateSpendingMap(spendingByDayOfTheMonthForTargetMonth, targetMonthDate)
                });

              case 8:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function makeRequest(_x26, _x27) {
        return _makeRequest13.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      dayInTargetMonth: dayInTargetMonth
    }
  };
});
/**
 * Makes a request to Identity to fetch the net total of transaction amounts for
 * each day in the target and previous months.
 * */

export var getDailyAverageTransactionsCashFlow = createAsyncAction('getDailyAverageTransactionsCashFlow ', function (_ref49) {
  var dayInEndMonth = _ref49.dayInEndMonth,
      dayInStartMonth = _ref49.dayInStartMonth;
  return {
    makeRequest: function () {
      var _makeRequest14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(_state, _ref50) {
        var apolloClient, response, averageSpendingByDayOfTheMonthList;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                apolloClient = _ref50.apolloClient;
                _context15.next = 3;
                return apolloClient.query({
                  query: FINANCIAL_TRANSACTIONS_AVERAGE_SPENDING_BY_DAY_OF_THE_MONTH,
                  variables: {
                    dateInTargetEndMonth: dayInEndMonth,
                    dateInTargetStartMonth: dayInStartMonth
                  },
                  fetchPolicy: 'network-only'
                });

              case 3:
                response = _context15.sent;
                averageSpendingByDayOfTheMonthList = _get(response, 'data.financialTransactionsAverageSpendingByDayOfTheMonth.averageSpendingByDayOfTheMonth', []);
                return _context15.abrupt("return", {
                  average_spending_per_day: averageSpendingByDayOfTheMonthList.reduce(function (acc, _ref51) {
                    var dayOfTheMonth = _ref51.dayOfTheMonth,
                        amount = _ref51.amount;
                    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, String(dayOfTheMonth), amount));
                  }, {})
                });

              case 6:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function makeRequest(_x28, _x29) {
        return _makeRequest14.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      dayInEndMonth: dayInEndMonth,
      dayInStartMonth: dayInStartMonth
    }
  };
});
/**
 * Makes a request to Identity to fetch the projected (estimated) income,
 * which is based on:
 *
 * (1) the user's self-reported monthly_net_income, or
 * (2) the user's self-reported annual_income / 12, or
 * (2) an average of their earning for the past two months
 * */

export var getCashFlowProjection = createAsyncAction('getCashFlowProjection', function (_ref52) {
  var dayInTargetMonth = _ref52.dayInTargetMonth;
  return {
    makeRequest: function () {
      var _makeRequest15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(_state, _ref53) {
        var apolloClient, cashFlowProjectionResult, _get3, earning;

        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                apolloClient = _ref53.apolloClient;
                _context16.next = 3;
                return apolloClient.query({
                  query: FINANCIAL_TRANSACTIONS_PROJECTION_FOR_MONTH,
                  variables: {
                    dateInTargetMonth: dayInTargetMonth
                  },
                  fetchPolicy: 'network-only'
                });

              case 3:
                cashFlowProjectionResult = _context16.sent;
                _get3 = _get(cashFlowProjectionResult, 'data.financialTransactionsProjectionForMonth', {}), earning = _get3.earning;
                return _context16.abrupt("return", {
                  projected_earning: earning
                });

              case 6:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function makeRequest(_x30, _x31) {
        return _makeRequest15.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      dayInTargetMonth: dayInTargetMonth
    }
  };
});
/**
 * Makes a request to Identity to delete a provider account.
 *
 * @param {string} providerAccountStateId Provider account state UUID to delete
 * @param {number} providerAccountId Provider account ID to delete (deprecated; use providerAccountStateId instead)
 * @param {boolean} getYodleeProfile Whether to return the Yodlee profile as part of the response
 * @param {object} serverRequest
 */

export var deleteProviderAccount = createAsyncAction('deleteProviderAccount', function (_ref54) {
  var providerAccountStateId = _ref54.providerAccountStateId,
      providerAccountId = _ref54.providerAccountId,
      getYodleeProfile = _ref54.getYodleeProfile;
  return {
    makeRequest: function () {
      var _makeRequest16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(_state, _ref55) {
        var apolloClient, deleteProviderAccountResult, financialData;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                apolloClient = _ref55.apolloClient;
                _context17.next = 3;
                return apolloClient.mutate({
                  mutation: DELETE_FINANCIAL_PORTAL,
                  variables: {
                    financialPortalId: providerAccountStateId
                  },
                  update: function update(cache) {
                    // When a portal is deleted we clear it from the Apollo cache. This way, cached queries on the client involving the portal
                    // will refetch from the server when it executes. This fixes cache invalidation problems such as trying to relink the same portal
                    // that was just deleted, which if we didn't do this would keep returning the deleted cached portal.
                    cache.data.delete("FinancialPortal:".concat(providerAccountStateId));
                  }
                });

              case 3:
                deleteProviderAccountResult = _context17.sent;

                if (!getYodleeProfile) {
                  _context17.next = 8;
                  break;
                }

                _context17.next = 7;
                return fetchFinancialData(apolloClient);

              case 7:
                financialData = _context17.sent;

              case 8:
                return _context17.abrupt("return", {
                  deleted: _get(deleteProviderAccountResult, 'data.deleteFinancialPortal.success'),
                  deletedPortalId: providerAccountStateId,
                  yodlee_profile: financialData ? transformFinancialDataProfileToLegacyDataShape(financialData) : null
                });

              case 9:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function makeRequest(_x32, _x33) {
        return _makeRequest16.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      providerAccountId: providerAccountId,
      providerAccountStateId: providerAccountStateId
    }
  };
});
/**
 * Makes a request to identity to start manually refreshing a specific provider account to get
 * that account's latest data. This is an async request that sets a flag called is_refreshing or is_auto_refreshing to
 * true on the providerAccountState. Once an account is refreshing, we poll identity continuously
 * to figure out once it has stopped refreshing.
 *
 * @param providerAccountStateId - Id of the provider account state
 * @param isAutoRefresh - Indicate whether this refresh call was invoked due to an auto refresh flag
 */

export var refreshProviderAccount = createAsyncAction('refreshProviderAccount', function (_ref56) {
  var providerAccountStateId = _ref56.providerAccountStateId,
      isAutoRefresh = _ref56.isAutoRefresh;
  return {
    makeRequest: function () {
      var _makeRequest17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(_state, _ref57) {
        var apolloClient, refreshFinancialPortalResult, financialPortal, financialAccountsByPortalIdResult, financialAccountsForPortal, providerAccount;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                apolloClient = _ref57.apolloClient;
                _context18.next = 3;
                return apolloClient.mutate({
                  mutation: REFRESH_FINANCIAL_PORTAL_MUTATION,
                  variables: convertYodleeRefreshParamsToFinancialPortalParams({
                    isAutoRefresh: isAutoRefresh,
                    providerAccountStateId: providerAccountStateId
                  })
                });

              case 3:
                refreshFinancialPortalResult = _context18.sent;
                financialPortal = _get(refreshFinancialPortalResult, 'data.refreshFinancialPortal');
                _context18.next = 7;
                return apolloClient.query({
                  query: GET_FINANCIAL_ACCOUNTS_BY_PORTAL,
                  fetchPolicy: 'network-only',
                  variables: {
                    financialPortalId: financialPortal.id
                  }
                });

              case 7:
                financialAccountsByPortalIdResult = _context18.sent;
                financialAccountsForPortal = _get(financialAccountsByPortalIdResult, 'data.financialAccountsByPortal.accounts');
                providerAccount = convertPortalToProviderAccount(financialPortal, financialAccountsForPortal); // the response for the refreshProviderAccount is expected to be the provider_account_state property, not the provider account:
                // https://github.com/NerdWallet/identity.nerdwallet/blob/8109c81d5210474ae508698c5311f5402f1d63b8/src/identity/flask_app/controllers/provider_accounts_controller.py#L429

                return _context18.abrupt("return", providerAccount.provider_account_state);

              case 11:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function makeRequest(_x34, _x35) {
        return _makeRequest17.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      isAutoRefresh: isAutoRefresh,
      providerAccountStateId: providerAccountStateId
    }
  };
});
export var deactivateYodlee = createAsyncAction('deactivateYodlee', function (_ref58) {
  var serverRequest = _ref58.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.deactivate({
        serverRequest: serverRequest
      });
    }
  };
});
/**
 * Updates the visiblity of a Yodlee financial account.
 *
 * @param {string} id - The id of the financial account to hide/show
 * @param {boolean} nwEnabled - A bool representing the desired hidden state of the financial
 * account
 */

export var updateFinancialAccountVisibility = createAsyncAction('updateFinancialAccountVisibility', function (_ref59) {
  var id = _ref59.id,
      nwEnabled = _ref59.nwEnabled;
  return {
    makeRequest: function () {
      var _makeRequest18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(_state, _ref60) {
        var apolloClient, updateFinancialAccountVisibilityResult, financialAccount;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                apolloClient = _ref60.apolloClient;
                _context19.next = 3;
                return apolloClient.mutate({
                  mutation: UPDATE_FINANCIAL_ACCOUNT_VISIBILITY,
                  variables: convertFinancialAccountVisibilityToYodleeAccountVisibility({
                    id: id,
                    nwEnabled: nwEnabled
                  }),
                  optimisticResponse: {
                    __typename: 'Mutation',
                    updateFinancialAccountVisibility: {
                      __typename: 'FinancialAccount',
                      id: id,
                      isHidden: !nwEnabled
                    }
                  }
                });

              case 3:
                updateFinancialAccountVisibilityResult = _context19.sent;
                financialAccount = _get(updateFinancialAccountVisibilityResult, 'data.updateFinancialAccountVisibility');
                return _context19.abrupt("return", {
                  account: convertFinancialAccountToYodleeAccount(financialAccount)
                });

              case 6:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      function makeRequest(_x36, _x37) {
        return _makeRequest18.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      id: id,
      nwEnabled: nwEnabled
    }
  };
});
/**
 * Gets a user's top takeaways based on their Yodlee data.
 */

export var getYodleeTopTakeaways = createAsyncAction('getYodleeTopTakeaways', function (_ref61) {
  var today = _ref61.today,
      serverRequest = _ref61.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.Yodlee.getTopTakeaways({
        categoryVersion: opts.transactionCategoryVersion,
        today: today,
        serverRequest: serverRequest
      });
    }
  };
});
/**
 * Login form field change action. Typically this is triggered by the FormBuilder component.
 * @param  {string} key
 * @param  {string} value
 */

export var loginFormFieldChanged = createAction('Login form field changed', function (key, value) {
  return {
    key: key,
    value: value
  };
});
/**
 * Mfa form field change action. Typically this is triggered by the FormBuilder component.
 * @param  {string} key
 * @param  {string} value
 */

export var mfaFormFieldChanged = createAction('MFA form field changed', function (key, value) {
  return {
    key: key,
    value: value
  };
});
/**
 * Updates provider id that's selected. In order for this to trigger a get provider details
 * request to the api you must be using Provider Details Middleware (see middlewares).
 * @type {function}
 * @param provider {object} provider details
 * @param provider.id {number} - id of provider (i.e. NW provider id)
 */

export var selectProvider = createAction('Select provider by ID');
export var selectProviderAccount = createAction('Select provider account by ID');
/**
 * Retry onboarding, i.e. let the user try to re-login to the same provider id but blow away other
 * changes.
 */

export var retryYodleeOnboarding = createAction('Retry yodlee onboarding');
/**
 * Start yodlee onboarding - typically by showing the yodlee modal. Optionally pass provider id and
 * provider account id to preselect
 * @param  {object} [options]
 * @param  {number} [options.providerId]
 * @param  {number} [options.providerAccountId]
 */

export var startYodleeOnboarding = createAction('Start yodlee onboarding');
/**
 * Close the yodlee onboarding modal.
 */

export var closeYodleeOnboarding = createAction('Close yodlee onboarding');
/**
 * Reset yodlee onboarding data to initial
 * @param shouldPreserveTopProviderType - Determines whether the `topProviderType` field should be reset. By default, this field will be reset
 */

export var resetYodleeOnboarding = createAction('Reset yodlee onboarding'); // Adding this for backwards compatibility in case mobile is depending on resetYodleeOnboarding
// TODO: remove soon.

export var unselectProviderAccount = retryYodleeOnboarding;
/**
 * Mark onboarding as being completed. The web flow uses this when the user clicks 'ok' from the
 * success step.
 */

export var markYodleeOnboardingAsComplete = createAction('Finish yodlee onboarding');
/**
 * An explicit duplicate of `readYodleeProfile` that will bypass middleware that conditionally rewrites the action to
 * fetch from query0/FDP. There are fields needed for Yodlee login that are only in the identity DB so we need to make
 * sure the request goes to identity.
 *
 * @param {Object} serverRequest - The node request object for auth context, if on the server
 */

export var fetchYodleeProfile = createAsyncAction('fetchYodleeProfile', function (serverRequest) {
  return {
    makeRequest: function () {
      var _makeRequest19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(_ref62, _ref63) {
        var identity, IdentitySDK, resp;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                identity = _ref62.identity;
                IdentitySDK = _ref63.IdentitySDK;
                _context20.next = 4;
                return IdentitySDK.readProfile({
                  id: identity.current.id
                }, NwApiSDK.IDENTITY_PROFILES.YODLEE_PROFILE, serverRequest);

              case 4:
                resp = _context20.sent;
                return _context20.abrupt("return", {
                  // Omit sensitive data from the response
                  data: _omit(resp, ['__meta', '__headers']),
                  profileType: NwApiSDK.IDENTITY_PROFILES.YODLEE_PROFILE
                });

              case 6:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      function makeRequest(_x38, _x39) {
        return _makeRequest19.apply(this, arguments);
      }

      return makeRequest;
    }()
  };
});
/**
 * Sets the flag determining if a user should fall back to Yodlee search
 * when Plaid Link closes. Takes a YodleeSearchFallback
 */

export var setYodleeSearchFallback = createAction('Set Yodlee search fallback');